import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './PremiumFoldersEmptyState';
import { AppState } from '../../../../../../types/store';
import { pushVerificationPopup } from '@wix/da-shared-react/pkg/VerificationPopup/actions';
import { getIsVerificationNeeded } from '@wix/da-shared-react/pkg/publicSession';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';
import { PapiUser } from '@wix/da-types-papi';
import { createOrOpenChatWithUser } from '@wix/da-shared-react/pkg/ChatV2/redux/actions';

export type StateProps = Pick<
  Props,
  'isVerificationNeeded' | 'isOwner' | 'user'
>;
export type DispatchProps = Pick<Props, 'pushVerificationPopup' | 'onOpenChat'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isVerificationNeeded: getIsVerificationNeeded(state),
  isOwner: isCurrentUserProfileOwner(state),
  user: getProfileOwnerUser(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  pushVerificationPopup,
  onOpenChat: (user: PapiUser) =>
    createOrOpenChatWithUser(
      `shop-premium-folders-empty-state-${user.useridUuid}`,
      user
    ),
};

export default connect(mapStateToProps, mapDispatchToProps);
